<a *ngFor="let e of value" [ngStyle]="{'display': getAppsPermissions(e.appId,e.permLevel) ? 'none' : ''}" [ngClass]="{'disabled' : getAppsPermissions(e.appId,e.permLevel), 'd-none': value.length>1}" [attr.id]="e.btnId" [class]="e.classList" [title]="e.title" 
                            (click)="getAppsPermissions(e.appId,e.permLevel) ? '' : routeTo(e)" href="javascript:void(0)">
    <i *ngIf="!e.stackIcon && e.iconClass" [class]="e.iconClass" aria-hidden="true"></i>
    <span *ngIf="e.stackIcon && e.iconClassList" [class]="e.stackClass">
        <i *ngFor="let ic of e.iconClassList" [class]="ic"></i>
    </span>
    {{e.text}}
</a>

<div *ngIf="value.length>1" class="container-azioni">
    <div class="position-relative bottone-dettaglio" tabindex="1" title="LISTA AZIONI">
        <div class="lista-dettaglio">
            <a *ngFor="let e of value" [ngStyle]="{'display': getAppsPermissions(e.appId,e.permLevel) ? 'none' : ''}"
                [ngClass]="{'disabled' : getAppsPermissions(e.appId,e.permLevel)}" [attr.id]="e.btnId" [class]="e.classList"
                [title]="e.title" (click)="getAppsPermissions(e.appId,e.permLevel) ? '' : routeTo(e)" href="javascript:void(0)">
                <i *ngIf="!e.stackIcon && e.iconClass" [class]="e.iconClass" aria-hidden="true"></i>
                <span *ngIf="e.stackIcon && e.iconClassList" [class]="e.stackClass">
                    <i *ngFor="let ic of e.iconClassList" [class]="ic"></i>
                </span>
                {{e.text}}
            </a>
        </div>
        <div class="btn {{value[0].mainBtnClass? value[0].mainBtnClass : 'btn-info'}}">
            <i class="fas fa-list-ul text-white"></i>
        </div>
    </div>
</div>
